import { dateToFormat } from 'helpers/formatters/date';
import { Column } from 'types/Table';
import { PullForwardTimeWindow } from 'types/PullForward';
import { formatToDate } from 'helpers/date';

export type RowType = {
  fromDate: string;
  returnComponent: string;
  numberPeriods: string;
};

export const getRowFormatted = (row: RowType) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      returnComponent: row.returnComponent,
      numberPeriods: row.numberPeriods,
      isTimeWindowEnable: true,
    },
  };
};

export const useTable = (
  data: Array<PullForwardTimeWindow> = [],
  onDeleteRow?: (fromDate: string) => void
) => {
  const columns: Column[] = [
    {
      Header: 'From Date',
      accessor: 'fromDate',
    },
    {
      Header: 'To Date',
      accessor: 'toDate',
    },
    {
      Header: 'Return Component',
      accessor: 'returnComponent',
    },
    {
      Header: 'Number of Periods',
      accessor: 'numberPeriods',
      className: 'text-right',
      Cell: (row) => <div className='text-right'>{row.value}</div>,
    },
  ];

  const actionDeleteRow = (
    onCloseModal: () => void,
    row: PullForwardTimeWindow[]
  ) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  return {
    data: data?.map((item: any) => ({
      ...item,
      fromDate: dateToFormat(new Date(item.fromDate), 'MM/dd/y'),
      toDate: formatToDate(item.fromDate, item.toDate),
      numberPeriods: item.pullForwardLength || item.numberPeriods,
      returnComponent: item.name,
    })),
    columns,
    actionDeleteRow,
  };
};
